export const messages = {
  en: {
    notepadManage: {
      search: {
        title: 'Search Conditions',
        noteType: 'Please select feedback type',
        roomName: 'Please select room',
        state: 'Please select status',
        createUserName: 'Please select registrant',
        objName: 'Please select owner name'
      },
      list: {
        title: 'Owner Feedback'
      },
      table: {
        noteType: 'Type',
        roomName: 'Room',
        objName: 'Contact',
        link: 'Contact Phone',
        state: 'Status',
        createTime: 'Record Time',
        createUserName: 'Registrant',
        title: 'Content'
      },
      state: {
        following: 'Following',
        completed: 'Completed',
        transferred: 'Transferred'
      },
      operation: {
        follow: 'Follow',
        progress: 'Progress',
        transfer: 'Transfer to Repair',
        repairDetail: 'Repair Detail'
      },
      tip: 'Tip: Please register at the business acceptance page',
      edit: {
        title: 'Edit',
        roomName: 'Room',
        objName: 'Contact',
        link: 'Contact Phone',
        noteType: 'Type',
        content: 'Content',
        selectNoteType: 'Please select feedback type'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Confirm to delete notepad?'
      },
      addDetail: {
        title: 'Follow Up',
        state: 'Status',
        content: 'Follow Content',
        selectState: 'Please select status',
        contentPlaceholder: 'Please enter follow content'
      },
      detail: {
        title: 'Follow Progress',
        index: 'No.',
        createUser: 'Handler',
        createTime: 'Handle Time',
        content: 'Handle Content'
      },
      ownerRepair: {
        title: 'Transfer to Repair',
        repairType: 'Repair Type',
        repairObjName: 'Room',
        repairName: 'Repairer',
        tel: 'Contact',
        appointmentTime: 'Appointment Time',
        context: 'Repair Content',
        selectRepairType: 'Please select repair type',
        repairObjNamePlaceholder: 'Please enter room',
        repairNamePlaceholder: 'Please enter repairer',
        telPlaceholder: 'Please enter contact',
        selectTime: 'Select appointment time',
        contextPlaceholder: 'Please enter repair content'
      },
      validate: {
        noteType: 'Type cannot be empty',
        title: 'Content cannot be empty',
        titleMaxLength: 'Content cannot exceed 256 characters',
        state: 'Status cannot be empty',
        content: 'Content cannot be empty',
        repairType: 'Repair type cannot be empty',
        repairObjName: 'Room cannot be empty',
        repairName: 'Repairer cannot be empty',
        repairNameLength: 'Repairer name must be between 2-10 characters',
        tel: 'Contact cannot be empty',
        telFormat: 'Invalid contact format',
        appointmentTime: 'Appointment time cannot be empty',
        context: 'Repair content cannot be empty',
        contextMaxLength: 'Repair content cannot exceed 2000 characters'
      }
    }
  },
  zh: {
    notepadManage: {
      search: {
        title: '查询条件',
        noteType: '请选择反馈类型',
        roomName: '请选择房屋',
        state: '请选择状态',
        createUserName: '请选择登记人',
        objName: '请选择业主名称'
      },
      list: {
        title: '业主反馈'
      },
      table: {
        noteType: '类型',
        roomName: '房屋',
        objName: '联系人',
        link: '联系电话',
        state: '状态',
        createTime: '记录时间',
        createUserName: '登记人',
        title: '内容'
      },
      state: {
        following: '跟进中',
        completed: '完成',
        transferred: '已转报修单'
      },
      operation: {
        follow: '跟进',
        progress: '进度',
        transfer: '转报修单',
        repairDetail: '报修详情'
      },
      tip: '温馨提示：请到业务受理页面登记',
      edit: {
        title: '修改',
        roomName: '房屋',
        objName: '联系人',
        link: '联系电话',
        noteType: '类型',
        content: '内容',
        selectNoteType: '请选择反馈类型'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除记事薄?'
      },
      addDetail: {
        title: '跟进',
        state: '状态',
        content: '跟进内容',
        selectState: '请选择状态',
        contentPlaceholder: '请填写跟进内容'
      },
      detail: {
        title: '跟进进度',
        index: '序号',
        createUser: '处理人',
        createTime: '处理时间',
        content: '处理内容'
      },
      ownerRepair: {
        title: '转报修单',
        repairType: '报修类型',
        repairObjName: '房屋',
        repairName: '报修人',
        tel: '联系方式',
        appointmentTime: '预约时间',
        context: '报修内容',
        selectRepairType: '请选择报修类型',
        repairObjNamePlaceholder: '请填写房屋',
        repairNamePlaceholder: '请填写报修人',
        telPlaceholder: '请填写联系方式',
        selectTime: '选择预约时间',
        contextPlaceholder: '请填写报修内容'
      },
      validate: {
        noteType: '类型不能为空',
        title: '内容不能为空',
        titleMaxLength: '内容不能超过256个字符',
        state: '状态不能为空',
        content: '内容不能为空',
        repairType: '报修类型不能为空',
        repairObjName: '房屋不能为空',
        repairName: '报修人不能为空',
        repairNameLength: '报修人名称必须在2至10字符之间',
        tel: '联系方式不能为空',
        telFormat: '联系方式格式不正确',
        appointmentTime: '预约时间不能为空',
        context: '报修内容不能为空',
        contextMaxLength: '报修内容不能超过2000个字符'
      }
    }
  },
  'zh-TW': {
    notepadManage: {
      search: {
        title: '查詢條件',
        noteType: '請選擇反饋類型',
        roomName: '請選擇房屋',
        state: '請選擇狀態',
        createUserName: '請選擇登記人',
        objName: '請選擇業主名稱'
      },
      list: {
        title: '業主反饋'
      },
      table: {
        noteType: '類型',
        roomName: '房屋',
        objName: '聯絡人',
        link: '聯繫電話',
        state: '狀態',
        createTime: '記錄時間',
        createUserName: '登記人',
        title: '內容'
      },
      state: {
        following: '跟進中',
        completed: '完成',
        transferred: '已轉保修單'
      },
      operation: {
        follow: '跟進',
        progress: '進度',
        transfer: '轉保修單',
        repairDetail: '保修詳情'
      },
      tip: '溫馨提示：請到業務受理頁面登記',
      edit: {
        title: '修改',
        roomName: '房屋',
        objName: '聯絡人',
        link: '聯繫電話',
        noteType: '類型',
        content: '內容',
        selectNoteType: '請選擇反饋類型'
      },
      delete: {
        title: '請確認您的操作',
        confirm: '確定刪除記事簿?'
      },
      addDetail: {
        title: '跟進',
        state: '狀態',
        content: '跟進內容',
        selectState: '請選擇狀態',
        contentPlaceholder: '請填寫跟進內容'
      },
      detail: {
        title: '跟進進度',
        index: '序號',
        createUser: '處理人',
        createTime: '處理時間',
        content: '處理內容'
      },
      ownerRepair: {
        title: '轉保修單',
        repairType: '保修類型',
        repairObjName: '房屋',
        repairName: '保修人',
        tel: '聯繫方式',
        appointmentTime: '預約時間',
        context: '保修內容',
        selectRepairType: '請選擇保修類型',
        repairObjNamePlaceholder: '請填寫房屋',
        repairNamePlaceholder: '請填寫保修人',
        telPlaceholder: '請填寫聯繫方式',
        selectTime: '選擇預約時間',
        contextPlaceholder: '請填寫保修內容'
      },
      validate: {
        noteType: '類型不能為空',
        title: '內容不能為空',
        titleMaxLength: '內容不能超過256個字符',
        state: '狀態不能為空',
        content: '內容不能為空',
        repairType: '保修類型不能為空',
        repairObjName: '房屋不能為空',
        repairName: '保修人不能為空',
        repairNameLength: '保修人名稱必須在2至10字符之間',
        tel: '聯繫方式不能為空',
        telFormat: '聯繫方式格式不正確',
        appointmentTime: '預約時間不能為空',
        context: '保修內容不能為空',
        contextMaxLength: '保修內容不能超過2000個字符'
      }
    }
  }
};